import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CircularProgress from '@mui/material/CircularProgress';
import makeStyles from '@mui/styles/makeStyles';
const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
    },
    bottom: {
        color: (props) => props.dark ? '#fff' : theme.palette.primary.main,
        opacity: 0.24,
    },
    top: {
        color: (props) => props.dark ? '#fff' : theme.palette.primary.main,
        position: 'absolute',
        left: 0,
    },
}));
function DeterminateLoadingCircular({ progress = 0, size = 48, thickness = 4, dark = false, }) {
    const classes = useStyles({ dark });
    return (_jsxs("div", Object.assign({ className: classes.root }, { children: [_jsx(CircularProgress, { variant: "determinate", className: classes.bottom, size: size, thickness: thickness, value: 100 }), _jsx(CircularProgress, { variant: "determinate", className: classes.top, size: size, thickness: thickness, value: progress })] })));
}
export default DeterminateLoadingCircular;
